module.exports = __webpack_public_path__ + "static/media/tecbound.086a798d.svg";